import React, { useState, useEffect, useCallback } from 'react';
import { Link,useLocation } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useAuth } from './AuthProvider';
import { handleResponse } from '../services/HandleResponse';
import { Checkbox, Typography, FormControlLabel, FormHelperText, LinearProgress } from '@mui/material';
import {Form} from "./Form";
import { ActivateCaptcha } from './ActivateCaptcha';


const useStyles = makeStyles((theme)=>({
    root: {
        maxWidth: 400
    },
    margin: {
        //margin: theme.spacing(2)
    }
}));


export const Login = ({ ...props }) => {
    const formContext = useForm({ shouldUnregister: true });

    const {handleSubmit, formState: { errors }, register,setValue } = formContext;
    const [generalLoginError, setGeneralLoginError] = useState('');
 
    const classes = useStyles();
    const [auth, { setUser }] = useAuth();
    const [loading, setLoading] = useState(false);
    const [loginInfo, setLoginInfo] = useState({});
    const [refresh, setRefresh] = useState(0);

    const location = useLocation();

    const onSubmitLogin = useCallback((data, token, event) => {

        var sendData = {...loginInfo };
        if(!sendData.userName)
                sendData.userName = data.userName;
        if(data.password)
                sendData.password = data.password;
        if(data.pin)
                sendData.pin = data.pin;
        if(typeof(data.keep) !== 'undefined')
                sendData.staySignedIn = data.keep?true:false;
        if(data.refreshToken)
            sendData.refreshToken = data.refreshToken;
       if(data.captcha)
            sendData.captcha = data.captcha;
        if(data.returnTo)
            sendData.returnTo = data.returnTo;
            
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(sendData)
        };

        return fetch(`/anywhere/api/users/authenticate`, requestOptions)
            .then(handleResponse)
            .then(data => {
              
                setLoginInfo(data)
                setLoading(false);
                setGeneralLoginError(null);

                if(data.status==='OK')  
                {
                    if(data.token)
                        window.localStorage.setItem("token", data.token);
                     if(data.refreshToken)
                        window.localStorage.setItem("refreshToken", data.refreshToken);
                     if(data.staySignedIn)
                        window.localStorage.setItem("staySignedIn", "true");
                     else
                        window.localStorage.removeItem("staySignedIn");

                     setUser(data);
                   
                    const from = data.returnTo || "/";
                    window.location.href = from;
                }

                return data;
            },
                error => {
                    console.log(JSON.stringify(error));
                    setLoading(false);
                    setRefresh((i)=>i+1);
                    //if(error.startsWith("Password Changed"))
                    //{
                        window.localStorage.removeItem("refreshToken");
                        setLoginInfo({...loginInfo, refreshToken: null});
                    //}
                    if(error?.message==="Failed to fetch")
                        error.message = "Network issue: Unable to connect to server";

                    setValue("code", "");
                    
                    setGeneralLoginError(error?.message || error || "Login Error");

                }
            );
    }, [setUser,loginInfo, setValue]);

    useEffect((event)=>{
        if(loading) return;
        if(loginInfo.refreshToken) return;
        if(loginInfo.userName) return;
        
        if(auth?.config?.remoteLogin)
            {
            window.location.href="/remote/login";
            }
        var refreshToken = window.localStorage.getItem("refreshToken");
        var staySignedIn = window.localStorage.getItem("staySignedIn")==="true";
        
        const params = new URLSearchParams(location.search);
        var returnTo= params.get('returnUrl');

        if(loginInfo.returnTo)
            return;

        if(!staySignedIn)
                refreshToken = null;

        var newInfo = {returnTo: returnTo||location.pathname, refreshToken:refreshToken, staySignedIn:staySignedIn};

        setLoginInfo(newInfo);

        if(!refreshToken) return;   // No auto login
        if(staySignedIn===false) return;

        setLoading(true);

        setTimeout(
        ()=>{
                onSubmitLogin(newInfo, "DISABLED", event);
            },
            500);
        
    },[handleSubmit,onSubmitLogin,setLoading, auth,loading,loginInfo,location]);

    if(auth?.config?.remoteLogin)
        return <></>;

    return (
        <FormProvider {...formContext}>
        <Form title="Sign in" setLoading={setLoading} onSubmit={onSubmitLogin}>
           
           {loginInfo.status==='OK' && 
            <><Grid item xs={12}>
                           
            <Typography gutterBottom={true}>Logged in. Redirecting...</Typography>
      
           </Grid>
           <Grid item xs={12}>
                           
            <LinearProgress></LinearProgress>

           </Grid>
           </>
            }    

           {loginInfo.status!=='OK' && loginInfo?.refreshToken && 
           <Grid item xs={12}>
                           
                <Typography gutterBottom={true}>Attempting to automatically log you in...</Typography>
 
               </Grid>
           }
           
            {loginInfo.status!=='OK' && !loginInfo?.refreshToken && !loginInfo?.requireMultiFactor && 
            <><Grid item xs={12}>
                           
                            <TextField
                                id="userName"
                                variant="standard"
                                {...register("userName", { required: "Please enter a user name" })}
                                className={classes.margin}
                                fullWidth
                                helperText={errors?.userName ? errors.userName.message : null}
                                label="User Name or Email"
                                error={errors?.userName}
                            />

                  
                    </Grid>
                        <Grid item xs={12}>
                   
                    
                                <TextField
                                    id="password"
                                    type="password"
                                    variant="standard"
                                    className={classes.margin} fullWidth
                                    {...register("password", { required: "Please enter a password" })}
                                    helperText={errors?.password ? errors.password.message : null}
                                    label="Password"
                                    error={errors?.password}
                                />
                          
                 
                </Grid>
                <Grid item xs={12}>
                        <FormControlLabel
                          
                            control={
                                <Checkbox
                                    id="keep"
                                    color="primary"
                                    {...register("keep")}
                                    onChange={(e)=>{
                                        setValue("keep", e.target.checked);
                                    }}
                                />
                            }
                            label="Stay signed in"
                            labelPlacement="end"
                    />
                </Grid>
                <Grid item xs={12}>
                    <ActivateCaptcha key={refresh} refresh={refresh}></ActivateCaptcha>
                    <TextField
                                    id="captcha"
                                    variant="standard"
                                    className={classes.margin} fullWidth
                                    {...register("captcha", { required: "This value is required." })}
                                    helperText={errors?.captcha ? errors.captcha.message : null}
                                    label={auth.config?.captchaLabel}
                                    error={errors?.captcha}
                                />
                          
                </Grid>
                </>}
                {loginInfo.status!=='OK' && !loginInfo?.refreshToken && loginInfo?.requireMultiFactor && <Grid item xs={12}>
                   
                    
                   <TextField
                       id="pin"
                       type="password"
                       variant="standard"
                       className={classes.margin} fullWidth
                       {...register("pin", { required: "Please enter your one time pin" })}
                       helperText={errors?.pin ? errors.pin.message : null}
                       label="Pin"
                       error={errors?.pin}
                   />
             
    
                </Grid>
                }
                {loading && <Grid item xs={12}>
                    <LinearProgress></LinearProgress>
                </Grid>}
                <Grid item xs={12}>
                    {generalLoginError && <FormHelperText error={true}>{generalLoginError}</FormHelperText>}
                </Grid>

                {!loginInfo?.refreshToken && <>
                <Grid item container xs={12} justifyContent="flex-end">
                    <Button variant="contained" color="primary" type="submit" >
                        Next
                    </Button>
                </Grid>

                        <Grid item xs={12}>
                            <Button component={Link}  color="primary"  to='/reset'>Reset Password</Button>
                            {auth.config.allowRegister && <Button component={Link} color="primary" to='/register'>Register</Button>}
                        </Grid>
                </>}

            </Form>
            {/*JSON.stringify(loginInfo)*/}
        </FormProvider>
    );
};